<template>
<div>
    <!-- Filtros de busqueda con boton -->
    <div class="ibox sombra-light" v-if="!detalle">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Errores Integraciones
            </h5>
        </div>
        <div class="ibox-content">
            <form @submit.prevent="getreporte">
                <b-overlay :show="buttonDisable" rounded="sm">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Fecha de inicio</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaInicioGrafico" v-model="form.fechaInicio" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Fecha de término</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaTerminoGrafico" v-model="form.fechaTermino" placeholder="Fecha de término" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Estado</label>
                                <div class="input-group">

                                    <select class="custom-select custom-select-sm" v-model="form.id_estado" style="width:200px; height:35px" name="type">
                                        <option value="Todos">Todos</option>
                                        <option v-for="(item, index) in estados" :key="index" :value="item.id">{{item.nombre}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="offset-md-6 col-md-6">
                            <b-button block variant="primary" type="submit" @submit="getreporte" :disabled="buttonDisable" :class="`buscar-info-dashboard`">Buscar</b-button>
                        </div>
                    </div>
                </b-overlay>
            </form>
        </div>
        <transition name="fade">
            <div class="graficos">
                <div class="ibox sombra-light">
                    <div class="ibox-content">
                        <b-row>
                            <b-col cols="12">
                                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12" @test="test">
                                    <template v-slot:detalles="item">
                                        <div>
                                            <button class="btn btn-primary" @click="test(item.data.id)">Ver</button>
                                        </div>
                                    </template>
                                </data-table>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    <div class="ibox sombra-light" v-else>
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Detalles
            </h5>
            <div class="btn-group pull-right">
                <button class="btn btn-xs btn-primary" @click="volver()">
                    <i class="fa fa-arrow-circle-left"></i> Volver
                </button>
            </div>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-3">Proveedor</div>
                <div class="col-md-3">Metodo</div>
                <div class="col-md-2">Codigo</div>
                <div class="col-md-2">Estado</div>
                <div class="col-md-2">Fecha</div>
                <div class="col-md-3">{{error.auditoria_integracion.proveedor.nombre}}</div>
                <div class="col-md-3">{{error.auditoria_integracion.parametro.metodo}}</div>
                <div class="col-md-2">{{error.auditoria_integracion.id_codigo_integracion}}</div>
                <div class="col-md-2">{{error.estado.nombre}}</div>
                <div class="col-md-2">{{error.auditoria_integracion.created_at}}</div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12 col-md-6">
                    Request <br>
                    <vue-json-pretty :data="getValue(error.auditoria_integracion.request)"> </vue-json-pretty>
                </div>
                <div class="col-sm-12 col-md-6">
                    Response <br>
                    <vue-json-pretty :data="getValue(error.auditoria_integracion.response)"> </vue-json-pretty>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Comentario</label>
                        <div class="input-group">
                            <textarea v-model="comentario" class="mb-2" rows="5" cols="40"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Estado</label>
                        <div class="input-group">
                            <select class="custom-select custom-select-sm" v-model="id_estado" style="width:200px; height:35px" name="type">
                                <option v-for="(item, index) in estado_disponibles" :key="index" :value="item.id">{{item.nombre}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="offset-md-6 col-md-6">
                    <b-button block variant="primary" @click="save" class="buscar-info-dashboard">Guardar</b-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
var moment = require('moment');
import { labels, locale } from "../../datepicker-intl.json";
import DataTable from '../../DataTableLuis.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    props: ['estados'],
    components: { DataTable, VueJsonPretty },
    data() {
        return {
            form: {
                fechaInicio: moment().subtract(1, "day").format("YYYY-MM-DD"),
                fechaTermino: moment().format("YYYY-MM-DD"),
                id_estado: "Todos"
            },
            datepicker: {
                etiquetas: labels,
                idioma: locale,
            },
            buttonDisable: false,
            parametrosValidos: false,
            mostrarGraficos: false,
            detalle: false,
            dt: {
                id: 'dt',
                columnas: [
                    { nombre: 'Id', nombre_variable: 'id' },
                    { nombre: 'Proveedor', nombre_variable: 'proveedor' },
                    { nombre: 'Metodo', nombre_variable: 'metodo' },
                    { nombre: 'Codigo Integracion', nombre_variable: 'codigo_integracion' },
                    { nombre: 'Estado', nombre_variable: 'estado' },
                    { nombre: 'Fecha', nombre_variable: 'created_at' },
                    { nombre: 'Detalles', nombre_variable: 'detalles', slot: 1 },
                ],
                datos: []
            },
            error: {},
            comentario: "",
            id_estado: "",
            estado_disponibles: []
        };
    },
    mounted() {

    },
    methods: {
        getValue(value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        },
        getreporte() {
            this.dt.datos = [];
            // console.log(this.form);
            this.buttonDisable = true;
            axios.post('errores-integraciones/reporte', this.form).then(response => {
                this.dt.datos = response.data.map(element => {
                    // console.log(element);
                    const row = {
                        id: element.id,
                        proveedor: element.proveedor.nombre,
                        metodo: element.parametro ? element.parametro.metodo_interno : "No se encuentra",
                        codigo_integracion: element.id_codigo_integracion,
                        estado: element.id_estado ? this.find_estado(element.id_estado) : "Pendiente",
                        created_at: moment(element.created_at).format("YYYY-MM-DD h:mm:ss a")
                    };
                    // this.dt.columnas.forEach(columna => {
                    //     if (columna.nombre_variable != "created_at"){
                    //         console.log(element);
                    //         row.push(element[columna.nombre_variable]);
                    //     }else {
                    //         let fecha = moment(element[columna.nombre_variable]).format("YYYY-MM-DD");
                    //         row.push(fecha);
                    //     }
                    // })
                    return row;
                });
                this.mostrarGraficos = true;

                // console.log(this.dt.datos);
                this.buttonDisable = false;
            }).catch(error => {
                this.buttonDisable = false;
                console.log(error);
            })
        },
        find_estado(id_estado) {
            let estado = this.estados.find(element => {
                return element.id == id_estado
            })
            return estado.nombre
        },
        test(id) {
            // console.log("HOLA");
            axios.get('errores-integraciones/' + id).then(response => {
                console.log(response);
                this.error = response.data;
                this.id_estado = this.error.id_estado;
                this.estado_disponibles = [];
                this.estados.forEach(element => {
                    if (element.id >= this.id_estado) {
                        this.estado_disponibles.push(element);
                    }
                });
                this.detalle = true;

            }).catch(error => {
                console.log(error);
            })
        },
        save() {
            if (this.id_estado == 3 && (this.comentario == "" || this.comentario == null)) {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Debes ingresar un comentario',
                    showConfirmButton: true,
                    timer: 5000,
                });
                return;
            }
            let data = {
                comentario: this.comentario,
                id_estado: this.id_estado,
                id: this.error.id
            }
            axios.post('errores-integraciones/save', data).then(response => {
                this.getreporte();
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Guardado',
                    text: 'con exito',
                    showConfirmButton: true,
                    timer: 1500,
                });
                this.detalle = false;
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 5000,
                });
            })
        },
        volver(){
            this.detalle = false;
            // console.log(this.dt.datos);
            this.getreporte();
        }
    },

}
</script>
